import React from 'react';
import { Row, Col, Button } from 'antd';

const Detail = ({ setStep }) => {

   const goToCheckAnswers = () => {
      setStep(2);
   };

   return (
      <Row justify="center">
         <Col md={19} className="mt-80 mb-150">
            <Row justify="center">
               <Col md={24}>
                  <h1 className="text-center mb-40">Revisa tus respuestas antes de finalizar</h1>
               </Col>
               <Col md={24}>
                  <h3>A continuación, te presentaremos todas las respuestas que haz dado, divididas en las secciones tal cual fueron contestadas, para que puedas revisarlas. Si quieres cambiar la respuesta, podrás hacerlo tocando el botón "editar" en la consigna correspondiente.
                  <br></br><br></br>
                  Luego de revisar cada sección, toque el botón "siguiente" hasta finalizar.
                  </h3>
               </Col>
            </Row>
         </Col>
         <Col lg={22} md={22} className="mb-50">
            <Row justify="end">
               <Col md={5}>
                  <Button onClick={goToCheckAnswers} type="primary" size="large" block>
                     Continuar
                  </Button>
               </Col>
            </Row>
         </Col>
      </Row>
   );
};

export default Detail;